import React from 'react'
import axios from 'axios'
import Select from 'react-select'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'

import FeedContainer from './Components/FeedContainer'

class Feed extends React.Component {
  constructor() {
    super()

    this.state = {
      data: {
        data: [],
        meta: {
          size: 0,
          page: 1,
          per_page: 7,
        },
      },
      scope: '',
      isDataFetched: false,
      axiosSource: axios.CancelToken.source(),
    }

    this.fetchData = this.fetchData.bind(this)
    this.onSortChange = this.onSortChange.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
  }

  componentDidMount() {
    this.fetchData(this.state.scope, this.state.data.meta.per_page)
  }

  fetchData(feedScope, perPage) {
    return axios.get('/api/internal/users/notifications', {
      params: { scope: feedScope, per_page: perPage },
      cancelToken: this.state.axiosSource.token,
    })
      .then((response) => this.onFetchSuccess(response))
      .catch((error) => {})
  }

  onFetchSuccess(response) {
    return this.setState({
      data: response.data,
      isDataFetched: true,
    })
  }

  // TODO: finalize sorting when api is prepared
  onSortChange(data) {
    this.setState({
      scope: data.value,
      isDataFetched: false,
    })

    this.fetchData(data.value, this.state.data.meta.per_page)
  }

  onPageChange(e) {
    if (e.target.textContent === 'show more') {
      this.fetchData(this.state.scope, 100)
    } else {
      this.fetchData(this.state.scope, 7)
    }
  }

  render() {
    const sortSelectOptions = [
      { value: '', label: 'All' },
      { value: 'feedback', label: 'Feedback' },
      { value: 'sales', label: 'Sales' },
      { value: 'jobs', label: '3D Projects' },
      { value: 'forum', label: 'Forum' },
      { value: 'following', label: 'Following' },
      { value: 'activity', label: 'My activity' },
      { value: 'purchases', label: 'Purchases' },
    ]

    return (
      <div className="row feed-section">
        <div className="col-12">
          <div className="card card--flat no-pad">
            <div className="dashboard-card dashboard-card--feed">
              <h3>
                Feed <Tooltip
                  tooltipClassName="tooltip--medium"
                  id="dashboard__feed"
                  content="Shows every activity related to your models and community topics you’ve participated in"
                >
                  <Icon type={['far', 'question-circle']} color="grey" notSpaced />
                </Tooltip>
              </h3>
              <Select
                className="Select-new col-6"
                id="feed-filter"
                options={sortSelectOptions}
                onChange={this.onSortChange}
                value={this.state.scope}
                searchable={false}
                clearable={false}
              />
              <FeedContainer
                isDataFetched={this.state.isDataFetched}
                notifications={this.state.data.data}
                meta={this.state.data.meta}
                onPageChange={this.onPageChange}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Feed
